import React, { useState } from "react";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import { useSelector, shallowEqual } from "react-redux";

/**
 * @param {(langIso: string) => React.ReactNode} multilanguageTabContent
 * @param {boolean} [contentDisabled]
 * @param {boolean} [stickyTabs=true] — Pestañas fijas al hacer scroll en formularios largos.
 * @param {number} [stickyTop=76] — Distancia desde arriba del viewport (px); hueco bajo barra Guardar/Volver.
 */
function MultilanguageTabBlock({
  multilanguageTabContent,
  contentDisabled = false,
  stickyTabs = true,
  stickyTop = 76,
}) {
  const [tab, setTab] = useState(0);
  const languages = useSelector(
    (store) => store.authentication?.languages,
    shallowEqual,
  );

  const handleChangeTabs = (_, newValue) => {
    setTab(newValue);
  };

  if (!languages) {
    return (
      <div>
        Loading... or an error occurred, please check your language settings
      </div>
    );
  }

  const validLanguages = languages.filter(
    (lang) =>
      lang &&
      lang.fullName &&
      lang.fullName.trim() !== "" &&
      lang.fullName.toLowerCase() !== "unknown" &&
      lang.isocode &&
      lang.isocode.trim() !== "",
  );

  const tabsBar = (
    <AppBar
      position="static"
      color="default"
      key="appbar"
      elevation={stickyTabs ? 0 : undefined}
      style={
        stickyTabs
          ? { boxShadow: "none", backgroundColor: "transparent" }
          : undefined
      }
    >
      <Tabs
        value={tab}
        onChange={handleChangeTabs}
        variant="scrollable"
        scrollButtons="auto"
        key="tabs"
      >
        {validLanguages.map((lang) => (
          <Tab key={lang.isocode} label={lang.fullName} />
        ))}
      </Tabs>
    </AppBar>
  );

  return (
    <>
      {stickyTabs ? (
        <div
          style={{
            position: "sticky",
            top:
              typeof stickyTop === "number" ? `${stickyTop}px` : stickyTop,
            zIndex: 1001,
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            marginBottom: "1rem",
            marginLeft: -4,
            marginRight: -4,
            paddingLeft: 4,
            paddingRight: 4,
          }}
        >
          {tabsBar}
        </div>
      ) : (
        tabsBar
      )}
      {validLanguages.map((lang, index) =>
        tab === index ? (
          <div key={`tabContainer-${index}`}>
            {contentDisabled ? (
              <fieldset
                disabled
                style={{ border: "none", padding: 0, margin: 0, minWidth: 0 }}
              >
                {multilanguageTabContent(lang.isocode)}
              </fieldset>
            ) : (
              multilanguageTabContent(lang.isocode)
            )}
          </div>
        ) : null,
      )}
    </>
  );
}

export default MultilanguageTabBlock;
